import { AccommodationRequest } from '@silbo/core';
import { queryOptions } from '@tanstack/react-query';
import { getAccommodationsFromRequestsQuery } from './get-accommodations-from-requests-query';

export const getAccommodationsFromRequestsQueryOptions = (requests: AccommodationRequest[]) =>
  queryOptions({
    queryKey: [
      getAccommodationsFromRequestsQuery(requests).className,
      getAccommodationsFromRequestsQuery(requests).toJSON(),
    ],
    queryFn: async () => {
      const query = getAccommodationsFromRequestsQuery(requests);
      return await query.find();
    },
    enabled: requests.length > 0,
    refetchOnWindowFocus: 'always',
    refetchOnReconnect: 'always',
  });
